import { shrpaApi } from "./axios";
import { ContentSummaryPayload, ContentSummaryStatusResults } from "@contracts/contentCalendar";

export default {
  async getAllSummaries(customerId: string, justValid = true): Promise<ContentSummaryPayload> {
    const uri = `/content-summary/${customerId}?justValid=${justValid}`;
    const { data } = await shrpaApi.get<ContentSummaryPayload>(uri);
    return data;
  },

  async generateContentSummary(customerId: string): Promise<string> {
    const uri = `/content-summary-gen/${customerId}`;
    const { data } = await shrpaApi.put<string>(uri);
    return data;
  },

  async checkContentSummaryStatus(customerId: string): Promise<ContentSummaryStatusResults> {
    const uri = `/content-summary/${customerId}/check-status`;
    const { data } = await shrpaApi.get<ContentSummaryStatusResults>(uri);
    return data;
  },
};
